import classNames from 'classnames';
import React, { cloneElement, ReactElement } from 'react';
import { LeftOutlined } from '@fx-ui/fine-design';

interface BackBtnProps {
    className?: string;
    onClick: () => void;
    text?: string;
    icon?: ReactElement;
}

const BackBtn: React.FC<BackBtnProps> = ({ onClick, className, text, icon }) => {
    return (
        <div className={classNames('fx-navigation-bar-back-btn', className)}>
            <LeftOutlined className="back-icon" onClick={onClick} />
            {icon && cloneElement(icon, { className: 'nav-icon' })}
            {text && (
                <span className="nav-text" title={text}>
                    {text}
                </span>
            )}
        </div>
    );
};

export default BackBtn;
